let slots = [];

/**
 * Adds the slot by appending new slots to the
 * existing slots array.
 * @typedef {Function} AddSlot
 * @param {Object} slot
 * @returns {void}
 */
export const addSlot = (slot) => {
  if (!slot || slot.key === undefined || slot.index === undefined) {
    throw new Error('Invalid data. Slot has to be an object with "key" and "index" properties');
  }

  slots.push(slot);
};

/**
 * Returns slots array.
 * @typedef {Function} GetSlots
 * @returns {Array<Object>} slots array
 */
export const getSlots = () => slots;

/**
 * Clears the slots.
 * @typedef {Function} ClearSlots
 * @returns {void}
 */
export const clearSlots = () => {
  slots = [];
};
